import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Environment } from '../models/environment.model';
import { AppInsightsService } from './application-insights.service';
import { GlobalErrorHandlerHelper } from './global-error-handler-helper.service';
import { LoggerService } from './logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private http = inject(HttpClient);
  private appData = inject(AppData);
  private appInsightsService = inject(AppInsightsService);
  private logger = inject(LoggerService);

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0 || (error.status >= 400 && error.status < 500)) {
        return;
      }
    }

    if (this.appData.environment !== Environment.Production) {
      this.logger.error('Global Error Handler:', error);
    }

    const errorData = {
      message: error.message || error || 'Unknown error',
      stack: error.stack || '',
      type: error.name || 'Error',
      appVersion: this.appData.clientVersion,
      environment: this.appData.environment,
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
      networkOnline: navigator.onLine,
    };

    if (GlobalErrorHandlerHelper.isErrorWhitelisted(errorData.message)) {
      return;
    }

    this.appInsightsService.trackError(error);

    this.http.post(`${this.appData.apiUrl}/api/v1/error-log`, errorData).subscribe({
      error: err => this.logger.error('Error logging failed', err),
    });
  }
}
